import React from 'react'
import { Box, Fade } from '@mui/material'
import { TabPanel } from '@mui/lab'

const FadeTabPanel = ({ children, className, tab, value }) => {
  return (
    <TabPanel value={value} className={className}>
      <Fade in={tab === value} mountOnEnter unmountOnExit>
        <Box>
          {children}
        </Box>
      </Fade>
    </TabPanel>
  )
}

export default FadeTabPanel
